import {
  call,
  put,
  takeLatest,
  takeEvery
} from "redux-saga/effects";
import {
  uploadFile
} from "utils/api";
import {
  ToastSuccess,
  ToastError
} from "components/Global/Toasts/Toasty";

import {
  defaultReturn,
  makePayload,
  generateDefaultActions,
  subKeySaga,
  requestSaga,
  fillDictionary
} from "../utils/helpers";

const initialState = {
  isActive: true,
  interval: 60
};

export const HEARTBEAT_POLL = generateDefaultActions("HEARTBEAT_POLL");
export const HEARTBEAT_GET_INTERVAL = generateDefaultActions("HEARTBEAT_INTERVAL");

export default function heartbeatReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case HEARTBEAT_POLL.success:
      return defaultReturn(state, payload.result, "isActive");
    case HEARTBEAT_POLL.failure:
      return defaultReturn(state, false, "isActive");
    case HEARTBEAT_GET_INTERVAL.success:
      return defaultReturn(state, parseInt(payload.result), "interval");
    default:
      return state;
  }
}

export function* heartbeatSaga() {
  yield takeEvery(HEARTBEAT_POLL.value, pollSaga);
  yield takeEvery(HEARTBEAT_GET_INTERVAL.value, heartbeatIntervalSaga);
}

export const poll = payload => makePayload(HEARTBEAT_POLL.value, payload);
export const getHeartbeatInterval = payload => makePayload(HEARTBEAT_GET_INTERVAL.value, payload);

function* pollSaga(payload) {
  const url = "/poll";
  yield requestSaga(HEARTBEAT_POLL, url);
}

function* heartbeatIntervalSaga(payload) {
  const url = "/getHeartbeatInterval";
  yield requestSaga(HEARTBEAT_GET_INTERVAL, url);
}

